import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Row.scss'

const Row = ({
	children,
	topMargin,
	bottomMargin,
	notPadded,
	center,
	verticalCenter
}) => {
	const paddingClass = notPadded ? styles.notPadded : ''
	const topMarginClass = topMargin ? styles.topMargin : ''
	const bottomMarginClass = bottomMargin ? styles.bottomMargin : ''
	const centerClass = center ? styles.center : ''
	const verticalCenterClass = verticalCenter ? styles.verticalCenter : ''

	return (
		<div
			styleName="row"
			className={[
				paddingClass,
				centerClass,
				topMarginClass,
				bottomMarginClass,
				verticalCenterClass
			].join(' ')}
		>
			{children}
		</div>
	)
}

Row.propTypes = {
	children: React.PropTypes.node
}

export default CSSModules(Row, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/Row.js